import type { Attribute } from "@commercetools/platform-sdk";

export const getAttribute: (
	attributes: Attribute[],
	attributeName: string,
) => Attribute | undefined = (attributes, attributeName) => {
	return attributes.find((attribute) => attribute.name === attributeName);
};
